import gql from 'graphql-tag';

const PAGE = 1;
const ITEMS_PER_PAGE = 500;

const QUERY_SITEMAP_SEARCH = gql`
  query SitemapSearch($locale: String = "en") {
    sitemapSearch(page: ${PAGE}, locale: $locale, itemsPerPage: ${ITEMS_PER_PAGE}) {
      search {
        url
        title
      }
    }
  }
`;

const getSitemapSearchQuery = client => ({ locale } = {}) =>
  client.query({
    query: QUERY_SITEMAP_SEARCH,
    variables: {
      locale
    }
  });

export default getSitemapSearchQuery;
